module.exports = __webpack_public_path__ + "static/pharmadata-0ac5be25fac3609026df9e4cfa2ce5ad.svg";